import { Grid } from '@mui/material';
import { CommonButtonWrapper, PageContent } from '@styles/CommonStyles';
import { FormPart } from '@modules/shared/components/FormPart';
import { PERMISSIONS_OPTIONS } from '@shared/constants/lists';
import { ColorPickerField } from '@shared/fields/ColorPickerField';
import { TextInputField } from '@shared/fields/TextInputField';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';

interface INewRoleForm {
  handleClose: () => void;
}

const formConfig = [
  {
    name: 'name',
    width: '100%',
    label: 'Role Name',
  },
  {
    name: 'permission',
    width: '100%',
    label: 'Role Type',
    options: PERMISSIONS_OPTIONS,
	isFitContentWidth: true,
    component: SelectAutocompleteField,
  },
  {
    name: 'commentsColor',
    width: '100%',
    label: 'Comment Color',
    color: 'red',
    edit: true,
    component: ColorPickerField,
  },
  {
    name: 'commentsColorPriority',
    width: '100%',
    label: 'Comment Color Priority',
    component: TextInputField,
    type: 'number',
  },
];

export const NewRoleForm = ({ handleClose }: INewRoleForm) => (
  <>
    <PageContent>
      <Grid container spacing={12}>
        <Grid item md={12}>
          <FormPart config={formConfig} />
        </Grid>
      </Grid>
    </PageContent>

    <CommonButtonWrapper direction="row">
      <CancelButton onClick={handleClose} />
      <SaveButton />
    </CommonButtonWrapper>
  </>
);
